import { Cart } from '@services/cart';

export const cartLineItemsToAgentPayload = (
  cart: Cart | null | undefined,
): CartUpdatePayload[] => {
  if (!cart?.lineItems?.length) return [];

  return cart.lineItems.map(({ productId, quantity }) => ({ productId, quantity }));
};
